"use client";
import React from "react";
import { Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";

const Slider: React.FC<{
  className?: string;
  spaceBetween?: number;
  slidesPerView?: number | "auto";
  children: React.ReactNode;
}> = ({ className, spaceBetween = 36, slidesPerView = "auto", children }) => {
  return (
    <div className={`relative ${className}`}>
      <Swiper
        cssMode={true}
        onSwiper={(swiper) => {
          swiper.pagination.init();
          swiper.pagination.update();
          swiper.on("scroll", () => {
            swiper.pagination.update();
          });
        }}
        slidesPerView={slidesPerView}
        breakpoints={
          slidesPerView !== "auto"
            ? {
                0: {
                  slidesPerView: 1,
                  spaceBetween,
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween,
                },
                768: {
                  slidesPerView,
                  spaceBetween,
                },
              }
            : undefined
        }
        spaceBetween={spaceBetween}
        navigation={true}
        pagination={{
          clickable: true,
          bulletActiveClass: "swiper-pagination-bullet-active",
          renderBullet: (index, className) => `<span class="${className}"></span>`,
        }}
        modules={[Navigation, Pagination]}
        className="slider"
      >
        {children}
      </Swiper>
    </div>
  );
};

export default Slider;
